import { createContext, Fragment, Children, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import _ from 'lodash';
import dayjs from 'utils/dayjs';
import { updateUser } from 'actions/user';
import { updateUser as updateClinicAdminUser } from 'actions/clinic_admins';
import { setAppLocale } from 'actions/misc';
import English from '../lang/en.json';
import French from '../lang/fr.json';

export const LanguageContext = createContext({
  locale: 'en',
  setLocale: () => {},
});

function LanguageProvider({
  children,
  updateUser: updateUserAction,
  updateClinicAdminUser: updateClinicAdminUserAction,
  setAppLocale: setAppLocaleAction,
  appLocale,
  user,
}) {
  const [locale, setLocaleState] = useState(appLocale);

  useEffect(() => {
    dayjs.locale(appLocale);
  }, []);

  const setLocale = newLocale => {
    dayjs.locale(newLocale);
    localStorage.setItem('locale', newLocale);
    setLocaleState(newLocale);
    setAppLocaleAction(newLocale);

    if (!_.isEmpty(user)) {
      if (user.clinic) {
        updateClinicAdminUserAction({ locale: newLocale }, () =>
          // TODO: Find a way to rerender components using reponse object
          window.location.reload(),
        );
      } else {
        updateUserAction({ locale: newLocale }, () =>
          window.location.reload(),
        );
      }
    }
  };

  return (
    <LanguageContext.Provider value={{ locale, setLocale }}>
      <IntlProvider
        locale={appLocale}
        messages={appLocale === 'en' ? English : French}
        textComponent={Fragment}
        minimumFractionDigits={2}
        maximumFractionDigits={2}
      >
        {Children.only(children)}
      </IntlProvider>
    </LanguageContext.Provider>
  );
}

LanguageProvider.propTypes = {
  children: PropTypes.element.isRequired,
  updateUser: PropTypes.func.isRequired,
  updateClinicAdminUser: PropTypes.func.isRequired,
  setAppLocale: PropTypes.func.isRequired,
  appLocale: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const {
    user,
    misc: { appLocale },
  } = state;

  return { user, appLocale };
}

export default connect(mapStateToProps, {
  updateUser,
  updateClinicAdminUser,
  setAppLocale,
})(LanguageProvider);
